import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { VistaMisDepositosDependenciasInput } from '../../models/vista-mis-depositos-dependencias.models';
import { NotificationService } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { ViveroFormInput } from '../../../../actividades/entity-viveros-grupo-especie/models/entity-viveros-grupo-especie.models';
import { Laboratorio } from '../../../../actividades/entity-laboratorios/laboratorios.model';
import { Deposito } from '../../../../actividades/entity-depositos/depositos.model';
import { SitioProcesamiento } from '../../../../actividades/entity-sitios-procesamiento/sitios-procesamiento.model';
import { MaquinaMovil } from '../../../../actividades/entity-maquinas-moviles/entity-maquinas-moviles.model';
import { Store } from '@ngrx/store';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { entityEntidadesProductivaChangeRequest } from '../../../entity-entidad-productiva/entity-entidades-productiva.actions';
import { EntidadesProductiva } from '../../../entity-entidad-productiva/entity-entidades-productiva.model';

@Component({
  selector: 'rpe-vista-mis-depositos-dependencias',
  templateUrl: './vista-mis-depositos-dependencias.component.html',
  styleUrls: ['./vista-mis-depositos-dependencias.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VistaMisDepositosDependenciasComponent implements OnInit {
  @Input() set vistaMisDepositosDependencias(data: VistaMisDepositosDependenciasInput) {
    this.entidadProductiva = data.entidadProductiva || []
    this.viveroFormInput = data.formInputViveros || []
    this.sitioProcesamiento = data.sitiosProcesamiento || []
    this.laboratorio = data.laboratorios || []
    this.depositos = data.depositos || []
    this.maquinasMoviles = data.maquinasMoviles || []
    this.comercializacion = this.entidadProductiva[0]?.comercializacion ?? false
    this.cdr.detectChanges()
  }

  backUrl: string = '/empresas/mi-empresa'

  comercializacion = false

  get sitiosYMaquinasMoviles(): {
    sitios: SitioProcesamiento[],
    maquinasMoviles: MaquinaMovil[],
  } {
    return {
      sitios: this.sitioProcesamiento,
      maquinasMoviles: this.maquinasMoviles
    }
  }

  get depositosYDependencias(): { deposito: Deposito[], edit: boolean } {
    return {
      deposito: this.depositos,
      edit: true,
    }
  }

  get labsInput(): { data: Laboratorio[], edit: boolean } {
    return {
      data: this.laboratorio,
      edit: true,
    }
  }

  get viverosInput(): { data: ViveroFormInput[], edit: boolean } {
    return {
      data: this.viveroFormInput,
      edit: true,
    }
  }

  showLab: boolean = true
  showCards: boolean = true
  showSitioProcesamiento: boolean = true
  showDeposito: boolean = true
  showVivero: boolean = true
  selectedValue: boolean | null = null;

  viveroFormInput: ViveroFormInput[] = []
  laboratorio: Laboratorio[] = []
  depositos: Deposito[] = []
  maquinasMoviles: MaquinaMovil[] = []
  sitioProcesamiento: SitioProcesamiento[] = []
  entidadProductiva: EntidadesProductiva[] = []

  constructor(
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
    public store: Store<State>,
  ) { }

  ngOnInit(): void {
    this.selectedValue = this.entidadProductiva[0]?.exclusivo_comercializacion ?? null;
  }

  onSuccess(): void {
    this.notificationService.success('Se ha guardado correctamente')
  }

  onUnicamenteComercializacion(event: any): void {
    const valorSeleccionado = event.value;
    this.selectedValue = valorSeleccionado;

    // Si la empresa es exclusiva de comercializacion, comercializa por definicion.
    if (valorSeleccionado) {
      this.comercializacion = true;
    }
    this.cdr.markForCheck();

    const entidad = {
      ...this.entidadProductiva[0],
      exclusivo_comercializacion: valorSeleccionado,
      comercializacion: this.comercializacion,
    };

    this.store.dispatch(
      entityEntidadesProductivaChangeRequest({ item: entidad })
    );

    this.notificationService.success('Se ha guardado correctamente');
  }

  onComercializacion(checked: boolean): void {
    this.comercializacion = checked;
    this.cdr.markForCheck();

    const entidad = {
      ...this.entidadProductiva[0],
      comercializacion: checked,
    };

    this.store.dispatch(
      entityEntidadesProductivaChangeRequest({ item: entidad })
    );

    this.notificationService.success('Se ha guardado correctamente');
  }
  
}
